module.exports = __webpack_public_path__ + "static/img/alarm.55632522.svg";